import { useApiClient, useFetchInfiniteES } from '@marageti/z4-lib';
import {
  SearchResult,
  FilterConstraint,
} from '@marageti/z4-sdk/lib/entity';
import { PartnerSearchHit } from '@marageti/z4-sdk/lib/travel';
import { useMemo } from 'react';

interface PossibleSearchFields {
  primaryCountries?: string[];
  fullText?: string;
  order?: string;
  sort?: string;
  status?: string[];
}

const usePartnerSearch = ({
  primaryCountries = [],
  fullText = '',
  order = '',
  sort = '',
  status = [],
}: PossibleSearchFields) => {
  const apiClient = useApiClient();

  const getSearchRequest = () => {
    const filterBy: FilterConstraint[] = [];

    const doFullTextSearch = fullText.length > 2;
    const sortBy = doFullTextSearch ? {} : {
      sortBy: [{
        field: sort,
        order,
      }],
    };

    if (primaryCountries.length) {
      filterBy.push({ field: 'primaryCountries.country', value: primaryCountries });
    }

    if (status.length) {
      filterBy.push({ field: 'status', value: [...status] });
    }

    return {
      filterBy,
      fullText: doFullTextSearch ? fullText : undefined,
      phrase: fullText.includes('@'),
      pagination: { limit: 30, page: 1 },
      ...sortBy,
    };
  };

  // Fetch and exicute search request
  const searchRequest = getSearchRequest();

  const {
    data,
    error,
    hasMore,
    isLoading,
    loadMore,
  } = useFetchInfiniteES<PartnerSearchHit>(apiClient.partnersClient.postPartnerSummarySearch, searchRequest, { revalidateOnFocus: false });

  const partners = useMemo(() => (
    data?.flatMap((searchResult: SearchResult<PartnerSearchHit>) => searchResult.hits)
  ), [data]);

  return {
    partners,
    error,
    hasMore,
    isLoading,
    loadMore,
    totalHits: data?.[0]?.totalHits || 0,
  };
};

export default usePartnerSearch;
